module.exports = __webpack_public_path__ + "img/ics_f_check_circle_gray.4835265a.svg";